import axios from 'axios'
import Vue from 'vue'
let axiosSAP = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    
    headers: {
        
        'Content-Type': 'application/json',
       
      },
  })
export async function create (context,form){
    try{
        let url = "api/addformsale"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('cliente',form.cliente)
        values.append('producto',form.producto) 
        values.append('cantidad',form.cantidad)
        values.append('trabajo',form.trabajo)
        values.append('fecha',form.fecha)
        values.append('hora',form.hora)
        values.append('otro',form.otro)
        values.append('solicitante',form.solicitante)
        //values.append('url',form.url)   
        values.append('observaciones',form.observaciones)
        values.append('status',form.status)      


        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        //disparamos el llenado de las url
        context.commit('setId',response.data.data)
    }catch(error){
        context.commit('vendedorError', error) // guardamos el mensaje de error
    }
    finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }
   
}
export async function fetchVentas(context,payload){
    try{
        let url = "api/getallformsale"//la direccion de la api
       
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
    
        let response = await Vue.axios({
            method: 'GET',
            url: url
        })
             
        context.commit('setVentas',response.data.data)
      
        }catch(error){
            context.commit('vendedorError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}
export async function fetchVentasForSeller(context,payload){
    try{
        let url = "api/getsalesforseller"//la direccion de la api
       
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('solicitante',payload)
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })
             
        context.commit('setVentas',response.data.data)
      
        }catch(error){
            context.commit('vendedorError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}
export async function addUrl(context,payload){
    try{
        let url = "api/addurl"//la direccion de la api
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('id',payload.id)
        values.append('link',payload.url)
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })  
        
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        //disparamos el llenado de las url
        
    }catch(error){
        context.commit('vendedorError', error) // guardamos el mensaje de error
    }
    finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }

}
export async function getOslp(context,payload){
    try{
        let url = "rci-web/oslp/getall"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosSAP({
            method: 'POST',
            url: url,
            data: values
        })
        
        context.commit('setOslp',response.data)
    }
    catch(error){
        context.commit('vendedorError', error) // guardamos el mensaje de error
    }
    finally{
        context.commit('setLoading',false,{root:true}) // finalizamos el loading
    }

}
export async function fetchVentasForSellerClosed(context,payload){
    try{
        let url = "api/getsalesforsellerclosed"//la direccion de la api
       
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        let values = new FormData()
        values.append('solicitante',payload)
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
        })
             
        context.commit('setVentas',response.data.data)
      
        }catch(error){
            context.commit('vendedorError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}